import { render, staticRenderFns } from "./IconSelectorPanel.vue?vue&type=template&id=594ad08c&"
import script from "./IconSelectorPanel.vue?vue&type=script&lang=ts&"
export * from "./IconSelectorPanel.vue?vue&type=script&lang=ts&"
import style0 from "./IconSelectorPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports